/** @format */

import { IThemeSelectItem } from './Types';

const Themes: IThemeSelectItem[] = [
	{ theme: 'light', themeIcon: '🌝' },
	{ theme: 'dark', themeIcon: '🌚' },
	{ theme: 'cupcake', themeIcon: '🧁' },
	{ theme: 'bumblebee', themeIcon: '🐝' },
	{ theme: 'emerald', themeIcon: '✳️' },
	{ theme: 'corporate', themeIcon: '🏢' },
	{ theme: 'synthwave', themeIcon: '🌃' },
	{ theme: 'retro', themeIcon: '👴' },
	{ theme: 'cyberpunk', themeIcon: '🤖' },
	{ theme: 'valentine', themeIcon: '🌸' },
	{ theme: 'halloween', themeIcon: '🎃' },
	{ theme: 'garden', themeIcon: '🌷' },
	{ theme: 'forest', themeIcon: '🌲' },
	{ theme: 'aqua', themeIcon: '🐟' },
	{ theme: 'lofi', themeIcon: '👓' },
	{ theme: 'pastel', themeIcon: '🖍' },
	{ theme: 'fantasy', themeIcon: '🧚‍♀️' },
	{ theme: 'wireframe', themeIcon: '📝' },
	{ theme: 'black', themeIcon: '🏴' },
	{ theme: 'luxury', themeIcon: '💎' },
	{ theme: 'dracula', themeIcon: '🧛‍♂️' },
	{ theme: 'cmyk', themeIcon: '🖨' },
	{ theme: 'autumn', themeIcon: '🍁' },
	{ theme: 'business', themeIcon: '💼' },
	{ theme: 'acid', themeIcon: '💊' },
	{ theme: 'lemonade', themeIcon: '🍋' },
	{ theme: 'night', themeIcon: '🌙' },
	{ theme: 'coffee', themeIcon: '☕️' },
	{ theme: 'winter', themeIcon: '❄️' },
];

export default Themes;
